import React from "react";
import Layout from "./Layout";
import { Card, CardContent } from "./components/ui/card";

import featureInventory from './assets/Barcode.jpg';
import featureProduct from './assets/feature_product.jpg';
import Scheduled from './assets/Scheduled.jpg';
import Reports from './assets/Reports.jpg';
import Patient from './assets/Patient.jpg';
import Payment from './assets/Payment.jpg';

export default function Features() {

  const featureList = [
    { title: "Clearing House Independent", img: featureProduct },
    { title: "Easy Inventory Management", img: featureInventory },
    { title: "Easily Schedule Your Workflow", img: Scheduled },
    { title: "Easy Comprehensive Reporting", img: Reports },
    { title: "Robust Patient Record", img: Patient },
    { title: "Patient Portals", img: Payment },
  ];

  return (
    <Layout>
      <h2 className="text-3xl md:text-4xl font-bold mb-6">
        NextDME Features
      </h2>

      <div className="grid md:grid-cols-3 gap-6">
        {featureList.map((feature) => (
          <Card
            key={feature.title}
            className="rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300"
          >
            <CardContent className="p-4">
              <img
                src={feature.img}
                alt={feature.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
              />
              <h3 className="font-semibold text-lg text-gray-800">
                {feature.title}
              </h3>
            </CardContent>
          </Card>
        ))}
      </div>
    </Layout>
  );
}